export enum IVmDetailsPageTabs {
  Overview = 'overview',
  ResourceUtilization = 'resource-utilization',
}
